import request from '../../axios';

export const getLoanRequest = async (loanRequestGuid: string) => {
  const {data}: {data: IGetLoanRequest} = await request.get(
    `/api/v2/payment/loan-request`,
    {
      params: {
        loan_request_guid: loanRequestGuid,
      },
    },
  );

  return data;
};
